import { Button as AntdButton } from 'antd';
import styled from 'styled-components';

export const Button = styled(AntdButton)`
  background: ${({ type }) => (type === 'primary' ? '#c5ea52' : '#fff')};
  border: 1px solid #c5ea52;
  color: #232529;
  font-weight: 600;
  &:hover,
  &:focus {
    color: #232529;
    background: ${({ type }) => (type === 'primary' ? '#b1d34a' : '#c5ea52')};
    border: 1px solid
      ${({ type }) => (type === 'primary' ? '#b1d34a' : '#c5ea52')};
  }
`;
